<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list row-key="UserId" ref="list" unit="质检返工" :page="page" :show-query="true" :get-data-func="api.list" v-if="trendShow" urlHash="production/reportmanagement/rework">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/pu/prTestRework').default,
      trendShow: true
    }
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  mounted() {},
  methods: {}
}
</script>
